// Checkbox.jsx
export default function Checkbox({
  checked,
  onChange,
  disabled = false,
  className = "",
}) {
  return (
    <label
      className={`inline-flex items-center gap-2 cursor-pointer select-none group ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${className}`}
    >
      {/* Real hidden input */}
      <input
        type="checkbox"
        className="sr-only" // Hides input but keeps it accessible
        checked={checked}
        disabled={disabled}
        // When input changes, we pass the new boolean value up
        onChange={(e) => onChange && onChange(e.target.checked)}
      />

      {/* Custom visual checkbox */}
      <span
        className={`relative w-[2rem] p-[0.2rem] h-[2rem] border rounded-[0.1rem] transition-all duration-300 flex items-center justify-center 
          ${
            checked
              ? "border-dark-blue"
              : "group-hover:border-dark-blue border-dusty-blue-20"
          }`}
      >
        <span
          className={`bg-dusty-green-dark w-full h-full transition-opacity duration-200 ${
            checked ? "opacity-100" : "opacity-0"
          }`}
        ></span>
      </span>
    </label>
  );
}